export enum ThemeMode {
  Light = 'light',
  Dark = 'dark',
}

export const DEFAULT_THEME_MODE = ThemeMode.Dark;
